import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { REDESIGN_TYPOGRAPHY, REDESIGN_SPACING } from '@/constants/residents/homeConstants';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { GlassCard } from '../GlassCard';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';

interface InviteCTAProps {
  onSendInvite: () => void;
  minHeight?: number;
}

export const InviteCTA: React.FC<InviteCTAProps> = React.memo(({ onSendInvite, minHeight }) => {
  const { colors } = useThemeColors();

  return (
    <GlassCard borderRadius={16} dashed style={minHeight ? { minHeight } : undefined}>
      <View style={[styles.container, minHeight != null && styles.containerStretch]}>
        <View style={[styles.iconCircle, { backgroundColor: colors.accent.blueBgMedium }]}>
          <RESIDENTS_SVG_COMPONENTS.LINKED_ACCOUNTS width={22} height={22} color={PRIMITIVE_COLORS.resioBlue} />
        </View>

        <Text style={styles.description}>
          <Text style={[styles.descriptionBold, { color: colors.text.muted }]}>Invite someone</Text>
          <Text style={[styles.descriptionLight, { color: colors.text.dim }]}> to connect and they'll be able to make payments on your behalf.</Text>
        </Text>

        <TouchableOpacity
          style={styles.button}
          onPress={onSendInvite}
          activeOpacity={0.8}
        >
          <RESIDENTS_SVG_COMPONENTS.SEND width={16} height={16} color={PRIMITIVE_COLORS.white} />
          <Text style={styles.buttonText}>Send Invitation</Text>
        </TouchableOpacity>
      </View>
    </GlassCard>
  );
});

InviteCTA.displayName = 'InviteCTA';

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    gap: 14,
  },
  containerStretch: {
    flex: 1,
    justifyContent: 'center',
  },
  iconCircle: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  description: {
    ...REDESIGN_TYPOGRAPHY.body,
    textAlign: 'center',
    lineHeight: 21,
  },
  descriptionBold: {
    fontWeight: '500',
  },
  descriptionLight: {
    fontWeight: '400',
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: PRIMITIVE_COLORS.resioBlue,
    borderRadius: 10,
    paddingHorizontal: 24,
    height: REDESIGN_SPACING.buttonHeight,
  },
  buttonText: {
    ...REDESIGN_TYPOGRAPHY.body,
    fontWeight: '600',
    color: PRIMITIVE_COLORS.white,
  },
});
